<template>
  <div class="drag-hint-wheel">
    <transition appear name="svg" @after-enter="onAfterEnter">
    <svg
      v-if="svgShown"
      version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="312.959px" height="137.28px" viewBox="0 0 312.959 137.28" enable-background="new 0 0 312.959 137.28" xml:space="preserve">
    <defs>
      <filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="18.544" y="17.729" width="275.901" height="100.04">
        <feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
      </filter>
    </defs>
    <mask maskUnits="userSpaceOnUse" x="18.544" y="17.729" width="275.901" height="100.04" id="back_1_">
      <g filter="url(#Adobe_OpacityMaskFilter)">
        <linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="-562.4663" y1="569.7651" x2="-561.4663" y2="569.7651" gradientTransform="matrix(256.9606 12.3566 17.1576 -356.8009 134784.7031 210299.0781)">
            <stop  offset="0" style="stop-color:#cdcdcd"/>
            <stop  offset="0.7533" style="stop-color:#cdcdcd"/>
            <stop  offset="1" style="stop-color:#cdcdcd"/>
        </linearGradient>
        <polygon fill="url(#SVGID_5_)" points="-578.069,-507.349 906.585,-435.956 855.287,630.823 -629.368,559.43     "/>
      </g>
    </mask>
    <linearGradient id="back_2_" gradientUnits="userSpaceOnUse" x1="-562.4658" y1="569.7573" x2="-561.4662" y2="569.7573" gradientTransform="matrix(256.961 12.3566 17.1576 -356.801 134785.0156 210299.0781)">
      <stop  offset="0" style="stop-color:#cdcdcd"/>
      <stop  offset="0.7533" style="stop-color:#f9f8f7"/>
      <stop  offset="1" style="stop-color:#f9f8f7"/>      
    </linearGradient>
    <path id="back" mask="url(#back_1_)" fill="url(#back_2_)" d="M37.271,41.879c3.051-1.487,46.003-23.997,109.823-24.149
      c37.962-0.053,83.44,8.425,129.574,34.568c16.825,9.515,22.752,30.87,13.236,47.695s-30.87,22.752-47.695,13.236
      c-34.746-19.598-67.19-25.445-95.115-25.499c-23.348-0.011-43.379,4.293-57.26,8.54c-6.936,2.117-12.321,4.208-15.779,5.674
      c-1.729,0.732-2.977,1.309-3.696,1.65c-0.359,0.172-0.587,0.285-0.677,0.33L65.7,95.983l4.131,7.862l-0.15,0.079L65.7,95.983
      l4.131,7.862c-17.111,8.991-38.272,2.409-47.264-14.702C13.577,72.032,20.159,50.871,37.271,41.879z"/>
    <g id="ring2" class="ring2-outside" :class="{'right': direction === 'right', 'left': direction === 'left'}" opacity="0.4">
      <g class="ring2-inside" :class="{'right': direction === 'right', 'left': direction === 'left'}">
        <defs>
          <rect id="SVGID_6_" x="20.464" y="39.93" width="66.16" height="66.16"/>
        </defs>
        <clipPath id="SVGID_7_">
          <use xlink:href="#SVGID_6_"  overflow="visible"/>
        </clipPath>
        <path clip-path="url(#SVGID_7_)" fill="#FFFFFF" d="M86.584,74.598c-0.877,18.248-16.382,32.33-34.63,31.452
          c-18.248-0.877-32.329-16.382-31.452-34.63c0.878-18.248,16.382-32.33,34.63-31.452C73.38,40.845,87.462,56.351,86.584,74.598"/>
      </g>
    </g>
    <g class="ring-outside" :class="{'right': direction === 'right', 'left': direction === 'left'}">
      <circle id="ring" class="ring-inside" :class="{'right': direction === 'right', 'left': direction === 'left'}" fill="none" stroke="#FFFFFF" stroke-width="5" stroke-miterlimit="10" cx="53.543" cy="73.009" r="33.079"/>
    </g>
    </svg>
    </transition>
  </div>
</template>

<script>
import delay from 'lodash/delay'

export default {
  name: 'DragHint',
  data: function () {
    return {
      svgShown: true
    }
  },
  methods: {
    onAfterEnter: function () {
      console.log('after enter')
      this.svgShown = false
      delay(() => {
        console.log('restart')
        this.svgShown = true
      }, 3000)
    }
  },
  props: {
    direction: {
      required: false,
      type: String,
      default: 'left'
    }
  }
}
</script>

<style scoped lang="scss">
@import 'variables';

.drag-hint-wheel {
  pointer-events: none;
  width: 100%;
  height: 70%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

svg {
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.svg-enter-active {
  transition: opacity 0.5s, transform 4s;
  .ring-outside,
  .ring2-outside {
    &.right {
      animation: left-right-anim 2s $ease-in-out-quint 2;
    }
    &.left {
      animation: right-left-anim 2s $ease-in-out-quint 2;
    }
  }

  .ring-inside,
  .ring2-inside {

    &.right {
      animation: down-up-down-right-anim 2s $ease-in-out-cubic 2;
    }
    &.left {
      animation: down-up-down-left-anim 2s $ease-in-out-cubic 2;
    }
  }
}
.svg-leave-active {
  transition: opacity 0.5s;
}

.svg-enter,
.svg-leave-to {
  opacity: 0;
}

@keyframes left-right-anim {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(209px, 0);
  }
}
@keyframes right-left-anim {
  0% {
    transform: translate(209px, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes down-up-down-right-anim {
  0% {
    transform: translate(0, 0);
    animation-timing-function: $ease-in-cubic;
  }
  50% {
    transform: translate(0, -20px);
    animation-timing-function: $ease-out-cubic;
  }
  100% {
    transform: translate(0, 12px);
  }
}
@keyframes down-up-down-left-anim {
  0% {
    transform: translate(0, 12px);
    animation-timing-function: $ease-in-cubic;
  }
  50% {
    transform: translate(0, -20px);
    animation-timing-function: $ease-out-cubic;
  }
  100% {
    transform: translate(0, 0);
  }
}

</style>



// WEBPACK FOOTER //
// src/atoms/MobileDragHintWheel.vue